import {
  AttributeCategory,
  AttributeType,
  SystemOnboarding,
} from 'constants/types'

import {
  ProfileAttribute,
  CatalogItem,
  twinStatusesCodes,
  twinStatusesMap,
} from 'shared'

import * as yup from 'yup'

export const getCatalogOptions = (data: CatalogItem[] | undefined) => {
  if (!data) return []
  return data.map((el) => ({
    label: el.text,
    value: el.code,
  }))
}

export const filenameSchema = yup
  .string()
  .matches(
    /^[\w\-._]+$/,
    'Invalid file name. Cannot contain < > : " / \\ | ? * characters.'
  )
  .min(1, 'File name cannot be empty')
  .max(255, 'File name is too long')

export const getAttributeValue = (
  attributes: ProfileAttribute[],
  attributeType: AttributeType,
  category?: AttributeCategory
) => {
  const activeAttribute = attributes
    .filter(({ category: itemCategory }) =>
      category ? itemCategory === category : true
    )
    .find(({ type: itemAttribute }) => itemAttribute === attributeType)
    ?.value as CatalogItem

  if (!activeAttribute) return null

  if (typeof activeAttribute === 'string') {
    return {
      value: attributeType,
      label: activeAttribute,
    }
  }

  return {
    value: activeAttribute.code,
    label: activeAttribute.text,
  }
}

export const getAttributeValues = (
  attributes: ProfileAttribute[],
  attributeType: AttributeType,
  category?: AttributeCategory
) => {
  const activeAttribute = attributes
    .filter(({ category: itemCategory }) =>
      category ? itemCategory === category : true
    )
    .find(({ type }) => type === attributeType)?.value as CatalogItem[]

  if (!activeAttribute?.length) return []

  return activeAttribute.map((el) => ({
    value: el.code,
    label: el.text,
  }))
}

export const setAttributeValue = (
  attributes: ProfileAttribute[] | undefined,
  {
    attribute,
    category,
    value,
  }: {
    attribute: AttributeType
    category: AttributeCategory
    value: CatalogItem | CatalogItem[] | string | null
  }
) => {
  //Creates new object references
  const newAttributes = attributes?.map((el) => ({ ...el })) || []

  const itemIdx = newAttributes.findIndex(
    ({ category: itemCategory, type }) => {
      return itemCategory === category && type === attribute
    }
  )
  if (itemIdx === -1) {
    newAttributes.push({
      category,
      type: attribute,
      value: value,
    } as ProfileAttribute)
  } else {
    newAttributes[itemIdx].value = value
  }
  return newAttributes
}

export const formatCreatorStatusText = (statusCode: string) => {
  if (
    statusCode === twinStatusesCodes['application-approved'] ||
    statusCode === twinStatusesCodes['application-rejected']
  ) {
    return twinStatusesMap['application-submitted']
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-expect-error
  return twinStatusesMap[statusCode]
}
export const getOnboardingFromStorage = (): SystemOnboarding =>
  JSON.parse(localStorage.getItem('onboarding') || '{}')

export const addUserInfoToStorage = (userId: string) =>
  localStorage.setItem('hue-twin', userId)

export const getUserInfoFromStorage = (): string => {
  const twinInfo = localStorage.getItem('hue-twin')
  return twinInfo || ''
}

export const removeUserInfoFromStorage = () => {
  localStorage.removeItem('hue-twin')
}
